import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav2").addClass('active')
var swiper = new Swiper(".mySwiper2", {
    spaceBetween: 14,
    slidesPerView: 4,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 14,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 4,
            spaceBetween: 14,
        }
    },
    thumbs: {
        swiper: swiper2,
    },
});
  var swiper2 = new Swiper(".mySwiper1", {
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
    },
    thumbs: {
        swiper: swiper,
    },
  });



  $(".section2 ul li").eq(0).addClass("active");
  $(".section2 .content-list .content").eq(0).addClass("active");
  // 主要功能
  var functionSwiper = new Swiper(".section3 .mySwiper", {
    slidesPerView: 4.5,
    spaceBetween: '1.38%',

    scrollbar: {
        el: ".section3 .swiper-pagination",
        draggable: true,
        hide: false,
        snapOnRelease: true
      },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1.5,
        spaceBetween: '1.38%',
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3.5,
            spaceBetween: '1.38%',
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 4.5,
            spaceBetween: '1.38%',
        }
    },
});
var text_h = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section3 .text').each(function() { //遍历相同样式名的元素
    var texth = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    text_h = texth > text_h ? texth : text_h; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.section3 .text').height(text_h); //给每一个元素设置相同的高度	


// 突出优势
var advantageSwiper = new Swiper(".section4 .mySwiper", {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: '5.06%',
    pagination: {
        el: ".section4 .swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: '3%',
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: '3%',
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: '5.06%',
        }
    },
});
//滚动定位
$(".product-nav ul li a").click(function() {
    let id = $(this).attr("href").split("#").pop()
    var top = $('#' + id).offset().top;
    $('html,body').animate({
        scrollTop: top - 110
    }, 500);
  })
  
  